<template>
  <div class="ntm__icon-c">
    <CheckIcon
      v-if="icon === 'check'"
      class="ntm__check-icon"
    />
    <AlertIcon
      v-if="icon === 'alert'"
      class="ntm__alert-icon"
    />
  </div>
</template>

<script>
  import AlertIcon from '@/assets/icons/alert-login-card.svg';
  import CheckIcon from '@/assets/icons/check-login-card.svg';

  export default {
    name: 'NotificationCardIcon',
    components: {
      CheckIcon,
      AlertIcon
    },
    props: {
      icon: {
        type: String,
        default: ''
      }
    }
  };
</script>

<style lang="scss" scoped>
  .ntm__icon-c {
    svg {
      width: 60px;
      height: 60px;
    }
  }
</style>
